import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { ApolloError } from "@apollo/client";
import { gql, useQuery } from "@apollo/client";
import type { Query } from "@/client/graphql/types/generated";
import { analysisEventKey, trackAnalysisEvent } from "@/utils/analysis/event";
const query = gql`
  query ConnectionCheck {
    connectionCheck {
      result
    }
  }
`;
type ConnectionPollingProp = {
  pollInterval: number;
};

/**
 * デバイスの接続確認用のポーリングを行う
 */
export const useConnectionCheckPolling = t0 => {
  const $ = _c(13);
  const {
    pollInterval
  } = t0;
  const t1 = process.env.NODE_ENV === "development" ? 0 : pollInterval;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      pollInterval: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    error,
    loading
  } = useQuery(query, t2);
  const isOnline = navigator.onLine;
  if (error && isOnline) {
    if (!error.networkError && error.message !== "Unauthorized") {
      trackAnalysisEvent(analysisEventKey.CONNECTION_CHECK_FAILED, {
        error: error.message
      });
    }
  }
  const [lastError, setLastError] = useState(null);
  let t3;
  let t4;
  if ($[2] !== error || $[3] !== lastError) {
    t3 = () => {
      if (lastError && !error) {
        trackAnalysisEvent(analysisEventKey.CONNECTION_CHECK_RECOVERED);
        setLastError(null);
      }
    };
    t4 = [error, lastError];
    $[2] = error;
    $[3] = lastError;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== error || $[7] !== lastError) {
    t5 = () => {
      if (error && !lastError && !isOnline) {
        setLastError(error);
      }
    };
    t6 = [error, lastError];
    $[6] = error;
    $[7] = lastError;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== error || $[11] !== loading) {
    t7 = {
      error,
      loading
    };
    $[10] = error;
    $[11] = loading;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};